import { render, staticRenderFns } from "./PriceRangeTable.vue?vue&type=template&id=22d5a708&"
import script from "./PriceRangeTable.vue?vue&type=script&lang=js&"
export * from "./PriceRangeTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceRangeTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports